// Custom Clearpay modal click PDP
document.addEventListener('DOMContentLoaded', e => {
    let clearpayInfoButton = document.querySelector('[data-clearpay-modal-show]');

    if (clearpayInfoButton) {
        let maxAttempts = 10,
        checkForClearpayModalBtn = setInterval(() => {
            let clearpayBlock = document.querySelector('square-placement'),
            clearpayBlockShadowRoot = clearpayBlock?.shadowRoot,
            clearpayModalBtn = clearpayBlockShadowRoot?.querySelector('.afterpay-link');

            if (clearpayModalBtn) {
                clearInterval(checkForClearpayModalBtn);

                clearpayInfoButton.addEventListener('click', e => {
                    e.preventDefault();
                    clearpayModalBtn.click();
                });

                clearpayInfoButton.classList.remove('custom-hide');
            }

            if (maxAttempts === 0) {
                clearInterval(checkForClearpayModalBtn);
            }
            maxAttempts--;
        }, 500);
    }
});

/**
 * Replaces the Klaviyo star rating button with a div to prevent default button behavior,
 * and when clicked, opens the reviews accordion and scrolls to it.
 */
document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(() => {
      const widget = document.querySelector('.klaviyo-star-rating-widget');
      if (widget) {
        const btn = widget.querySelector('button, [role="button"]');
        if (btn) {
          const div = document.createElement('div');
          div.innerHTML = btn.innerHTML;
          div.className = btn.className;
          if (btn.hasAttribute('tabindex')) {
            div.setAttribute('tabindex', btn.getAttribute('tabindex'));
          }
          btn.replaceWith(div);

          div.addEventListener('click', () => {
            const accordionBtn = document.querySelector(
              '[data-app-block-collapse]'
            );

            if (accordionBtn && accordionBtn.getAttribute('aria-expanded') !== 'true') {
              accordionBtn.click();
            }

           if (accordionBtn) {
                const rect = accordionBtn.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const offset = 77 + 45;
                window.scrollTo({
                top: rect.top + scrollTop - offset,
                behavior: 'smooth'
                });
              }
          });
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

 // PDP Flickity Carousel video Fix
document.addEventListener('DOMContentLoaded', function() {

    var flickityElement = document.querySelector('.product__media-list-wrapper .product__media-list');
    if (!flickityElement) return;

    // Filter videos on desktop immediately so Flickity never includes them (no flash, no gap)
    function filterVideosForDesktop() {
        var isDesktop = window.innerWidth >= 1000;

        if (isDesktop) {
            var videoItems = flickityElement.querySelectorAll('.product__media-item.is-video-item:not([data-desktop-filtered="true"])');
            videoItems.forEach(function(item) {
                item.classList.add('is-filtered');
                item.setAttribute('data-desktop-filtered', 'true');
            });
            var videoDots = document.querySelectorAll('.product__media .dots-nav__item.is-video-dot:not([data-desktop-filtered="true"])');
            videoDots.forEach(function(dot) {
                dot.classList.add('is-filtered');
                dot.setAttribute('data-desktop-filtered', 'true');
            });
            var videoThumbnails = document.querySelectorAll('.product__media .product__thumbnail-item.is-video-thumbnail:not([data-desktop-filtered="true"])');
            videoThumbnails.forEach(function(thumb) {
                thumb.classList.add('is-filtered');
                thumb.setAttribute('data-desktop-filtered', 'true');
            });
            var flkty = typeof ThemeFlickity !== 'undefined' && ThemeFlickity.data(flickityElement);
            if (flkty) flkty.reloadCells();
        } else {
            var filteredVideoItems = flickityElement.querySelectorAll('.product__media-item.is-video-item[data-desktop-filtered="true"]');
            filteredVideoItems.forEach(function(item) {
                item.classList.remove('is-filtered');
                item.removeAttribute('data-desktop-filtered');
            });
            var filteredVideoDots = document.querySelectorAll('.product__media .dots-nav__item.is-video-dot[data-desktop-filtered="true"]');
            filteredVideoDots.forEach(function(dot) {
                dot.classList.remove('is-filtered');
                dot.removeAttribute('data-desktop-filtered');
            });
            var filteredVideoThumbnails = document.querySelectorAll('.product__media .product__thumbnail-item.is-video-thumbnail[data-desktop-filtered="true"]');
            filteredVideoThumbnails.forEach(function(thumb) {
                thumb.classList.remove('is-filtered');
                thumb.removeAttribute('data-desktop-filtered');
            });
            var flkty = typeof ThemeFlickity !== 'undefined' && ThemeFlickity.data(flickityElement);
            if (flkty) flkty.reloadCells();
        }
    }

    filterVideosForDesktop();

    // Helper to check if Tapcart is present (consistent across all functions)
    function isTapcartPresent() {
        return !!(document.body && document.body.classList.contains('tapcart-webbridge')) ||
               !!(document.querySelector && document.querySelector('.tapcart-webbridge'));
    }

    function updateFlickity(){
        var flkty = ThemeFlickity.data(flickityElement);
        if (!flkty) return;

        var isSkippingVideo = false; // Flag to prevent infinite loops

        // On desktop or Tapcart, skip video items when navigating
        function shouldSkipVideos() {
            var isDesktopWidth = window.innerWidth >= 1000;
            return isDesktopWidth || isTapcartPresent();
        }

        function getNextNonVideoItem(currentElement, direction) {
            var allItems = Array.from(flickityElement.querySelectorAll('.product__media-item:not(.is-filtered)'));
            var currentIndex = allItems.indexOf(currentElement);
            if (currentIndex === -1) return null;

            // Try next items in direction
            for (var i = currentIndex + direction; i >= 0 && i < allItems.length; i += direction) {
                if (!allItems[i].classList.contains('is-video-item')) {
                    return allItems[i];
                }
            }

            // If we hit the end, wrap around
            if (direction === 1) {
                // Wrapping forward - start from beginning
                for (var i = 0; i < currentIndex; i++) {
                    if (!allItems[i].classList.contains('is-video-item')) {
                        return allItems[i];
                    }
                }
            } else {
                // Wrapping backward - start from end
                for (var i = allItems.length - 1; i > currentIndex; i--) {
                    if (!allItems[i].classList.contains('is-video-item')) {
                        return allItems[i];
                    }
                }
            }

            return null;
        }

        function getNextNonVideoCellIndex(flkty, direction) {
            var currentIndex = flkty.selectedIndex;
            if (currentIndex === -1) return null;

            var cellCount = flkty.cells.length;
            var checked = 0;

            // Try next cells in direction
            for (var i = currentIndex + direction; checked < cellCount; i += direction, checked++) {
                // Handle wrap-around
                if (i < 0) i = cellCount - 1;
                if (i >= cellCount) i = 0;

                var cell = flkty.cells[i];
                if (cell && cell.element && !cell.element.classList.contains('is-video-item')) {
                    return i;
                }
            }

            return null;
        }

        // On desktop or Tapcart, override next/previous/select/selectCell to skip videos proactively
        if (shouldSkipVideos()) {
            var originalNext = flkty.next;
            var originalPrevious = flkty.previous;
            var originalSelect = flkty.select;
            var originalSelectCell = flkty.selectCell;
            var isSkippingVideo = false;

            // Helper to get what the next cell would be
            function getNextCellIndex(currentIndex, direction) {
                var allItems = Array.from(flickityElement.querySelectorAll('.product__media-item:not(.is-filtered)'));
                var nextIndex = currentIndex + direction;
                if (nextIndex < 0) return allItems.length - 1;
                if (nextIndex >= allItems.length) return 0;
                return nextIndex;
            }

            flkty.next = function(isWrapAround) {
                var currentIndex = flkty.selectedIndex;
                var cellCount = flkty.cells.length;
                if (cellCount === 0) return flkty;

                // Find what the next cell would be
                var nextIndex = currentIndex + 1;
                if (nextIndex >= cellCount) {
                    if (isWrapAround) nextIndex = 0;
                    else return flkty;
                }

                // Check if next cell is a video
                var nextCell = flkty.cells[nextIndex];
                if (nextCell && nextCell.element && nextCell.element.classList.contains('is-video-item')) {
                    // Skip to next non-video
                    var skipIndex = getNextNonVideoCellIndex(flkty, 1);
                    if (skipIndex !== null) {
                        return originalSelect.call(flkty, skipIndex);
                    }
                }

                // Normal next - call original
                return originalNext.call(flkty, isWrapAround);
            };

            flkty.previous = function(isWrapAround) {
                var currentIndex = flkty.selectedIndex;
                var cellCount = flkty.cells.length;
                if (cellCount === 0) return flkty;

                // Find what the previous cell would be
                var prevIndex = currentIndex - 1;
                if (prevIndex < 0) {
                    if (isWrapAround) prevIndex = cellCount - 1;
                    else return flkty;
                }

                // Check if previous cell is a video
                var prevCell = flkty.cells[prevIndex];
                if (prevCell && prevCell.element && prevCell.element.classList.contains('is-video-item')) {
                    // Skip to previous non-video
                    var skipIndex = getNextNonVideoCellIndex(flkty, -1);
                    if (skipIndex !== null) {
                        return originalSelect.call(flkty, skipIndex);
                    }
                }

                // Normal previous - call original
                return originalPrevious.call(flkty, isWrapAround);
            };

            // Override select to skip videos when they're selected directly (dragging)
            flkty.select = function(cell) {
                if (isSkippingVideo) {
                    return originalSelect.call(flkty, cell);
                }

                var targetElement = null;
                if (typeof cell === 'string') {
                    targetElement = document.querySelector(cell);
                } else if (typeof cell === 'number' && flkty.cells && flkty.cells[cell]) {
                    targetElement = flkty.cells[cell].element;
                } else if (cell && cell.nodeType === 1) {
                    targetElement = cell;
                }

                // If trying to select a video, skip to next non-video
                if (targetElement && targetElement.classList && targetElement.classList.contains('is-video-item')) {
                    isSkippingVideo = true;
                    var currentElement = flkty.selectedElement;
                    var allItems = Array.from(flickityElement.querySelectorAll('.product__media-item:not(.is-filtered)'));
                    var currentIndex = allItems.indexOf(currentElement);
                    var targetIndex = allItems.indexOf(targetElement);
                    var direction = targetIndex > currentIndex ? 1 : -1;

                    var nextItem = getNextNonVideoItem(currentElement, direction);
                    if (!nextItem) {
                        nextItem = getNextNonVideoItem(currentElement, direction * -1);
                    }

                    if (nextItem) {
                        var result = originalSelect.call(flkty, nextItem);
                        setTimeout(function() {
                            isSkippingVideo = false;
                        }, 50);
                        return result;
                    }

                    isSkippingVideo = false;
                    return flkty;
                }

                // Normal selection for non-video items
                return originalSelect.call(flkty, cell);
            };

            // Override selectCell (used by flickity-carousel for thumbnail clicks)
            flkty.selectCell = function(cell) {
                if (isSkippingVideo) {
                    return originalSelectCell.call(flkty, cell);
                }

                var targetElement = null;
                if (typeof cell === 'string') {
                    targetElement = document.querySelector(cell);
                } else if (typeof cell === 'number' && flkty.cells && flkty.cells[cell]) {
                    targetElement = flkty.cells[cell].element;
                } else if (cell && cell.nodeType === 1) {
                    targetElement = cell;
                }

                if (targetElement && targetElement.classList && targetElement.classList.contains('is-video-item')) {
                    isSkippingVideo = true;
                    var currentElement = flkty.selectedElement;
                    var allItems = Array.from(flickityElement.querySelectorAll('.product__media-item:not(.is-filtered)'));
                    var currentIndex = allItems.indexOf(currentElement);
                    var targetIndex = allItems.indexOf(targetElement);
                    var direction = targetIndex > currentIndex ? 1 : -1;

                    var nextItem = getNextNonVideoItem(currentElement, direction);
                    if (!nextItem) {
                        nextItem = getNextNonVideoItem(currentElement, direction * -1);
                    }

                    if (nextItem) {
                        var result = originalSelectCell.call(flkty, nextItem);
                        setTimeout(function() {
                            isSkippingVideo = false;
                        }, 50);
                        return result;
                    }
                    isSkippingVideo = false;
                }

                return originalSelectCell.call(flkty, cell);
            };
        }

        // Handle video play/pause
        flkty.on("change", function() {
            // On desktop or Tapcart, double-check we didn't land on a video (fallback)
            if (shouldSkipVideos()) {
                var selectedElement = flkty.selectedElement;
                if (selectedElement && selectedElement.classList.contains('is-video-item')) {
                    var nextItem = getNextNonVideoItem(selectedElement, 1);
                    if (nextItem) {
                        flkty.select(nextItem);
                        return;
                    }
                    var prevItem = getNextNonVideoItem(selectedElement, -1);
                    if (prevItem) {
                        flkty.select(prevItem);
                        return;
                    }
                }
            }

            flkty.cells.forEach(function(cell, i) {
                if (cell.element == flkty.selectedElement) {
                    // play video if active slide contains one
                    // use <video playsinline ..> in your html to assure it works on ios devices
                    var video = cell.element.querySelector("video");
                    if (video) {
                        video.play();
                    }
                    return;
                }
                // pause all other videos
                var video = cell.element.querySelector("video");
                if (video) {
                    video.pause();
                }
            });
        });

        // On desktop or Tapcart, intercept thumbnail clicks to prevent selecting videos
        // On mobile (non-Tapcart), videos should be fully accessible
        if (shouldSkipVideos()) {
            var flickityControls = document.querySelector('flickity-controls[controls="' + flickityElement.id + '"]');
            if (flickityControls) {
                // Only intercept clicks on video thumbnail buttons
                var videoThumbnails = flickityControls.querySelectorAll('.product__thumbnail-item');
                videoThumbnails.forEach(function(thumbnail) {
                    var mediaId = thumbnail.getAttribute('data-media-id');
                    if (mediaId) {
                        var videoItem = flickityElement.querySelector('.product__media-item.is-video-item[data-media-id="' + mediaId + '"]');
                        if (videoItem) {
                            thumbnail.addEventListener('click', function(e) {
                                e.preventDefault();
                                e.stopImmediatePropagation();

                                // Find next non-video item
                                var allItems = Array.from(flickityElement.querySelectorAll('.product__media-item:not(.is-filtered)'));
                                var videoIndex = allItems.indexOf(videoItem);
                                var nextItem = null;

                                // Try next items first
                                for (var i = videoIndex + 1; i < allItems.length; i++) {
                                    if (!allItems[i].classList.contains('is-video-item')) {
                                        nextItem = allItems[i];
                                        break;
                                    }
                                }
                                // If no next item, try previous
                                if (!nextItem) {
                                    for (var i = videoIndex - 1; i >= 0; i--) {
                                        if (!allItems[i].classList.contains('is-video-item')) {
                                            nextItem = allItems[i];
                                            break;
                                        }
                                    }
                                }

                                if (nextItem) {
                                    var controlButton = flickityControls.querySelector('[aria-controls="' + nextItem.id + '"]');
                                    if (controlButton) {
                                        controlButton.click();
                                    }
                                }
                                return false;
                            }, true); // Use capture phase to intercept before flickity-controls handler
                        }
                    }
                });
            }
        }
    }


    function mutationObserver(element, callback) {
      var observer = new MutationObserver(function(){
          if(element.hasAttribute('click-nav')){
            observer.disconnect();
            callback();
          }
      });
      observer.observe(element, { attributes: true, childList: true });
    }

    mutationObserver(flickityElement, updateFlickity);

    // Run updateFlickity when Flickity is ready (so overrides are applied)
    flickityElement.addEventListener('flickity:ready', updateFlickity);

    // Desktop/Tapcart: intercept ANY click that would select a video (capture phase, before theme)
    document.addEventListener('click', function(e) {
        if (window.innerWidth < 1000 && !isTapcartPresent()) return;
        var button = e.target.closest && e.target.closest('[data-action="select"]');
        if (!button) return;
        var ariaControls = button.getAttribute('aria-controls');
        if (!ariaControls) return;
        var slideEl = document.getElementById(ariaControls);
        if (!slideEl || !slideEl.classList.contains('is-video-item')) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var controlsEl = button.closest('flickity-controls');
        if (!controlsEl) return;
        var carouselId = controlsEl.getAttribute('controls');
        if (!carouselId) return;
        var carousel = document.getElementById(carouselId);
        if (!carousel) return;
        var flkty = typeof ThemeFlickity !== 'undefined' && ThemeFlickity.data(carousel);
        if (!flkty) return;

        var allItems = Array.from(carousel.querySelectorAll('.product__media-item:not(.is-filtered)'));
        var videoIndex = allItems.indexOf(slideEl);
        var nextItem = null;
        for (var i = videoIndex + 1; i < allItems.length; i++) {
            if (!allItems[i].classList.contains('is-video-item')) {
                nextItem = allItems[i];
                break;
            }
        }
        if (!nextItem) {
            for (var i = videoIndex - 1; i >= 0; i--) {
                if (!allItems[i].classList.contains('is-video-item')) {
                    nextItem = allItems[i];
                    break;
                }
            }
        }
        if (nextItem) {
            flkty.selectCell(nextItem);
        }
    }, true);

    // Handle play button clicks to scroll to video
    function initPlayButtons() {
        var playButtons = document.querySelectorAll('.product__media-play-button[data-action="scroll-to-video"]');
        playButtons.forEach(function(button) {
            // Remove existing listeners to avoid duplicates
            var newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);

            newButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                // Don't allow navigation to videos on desktop or Tapcart
                if (window.innerWidth >= 1000 || isTapcartPresent()) {
                    return;
                }

                var mediaList = flickityElement;
                if (!mediaList) return;

                // Check if we're already on a video item
                var currentSelected = mediaList.querySelector('.product__media-item.is-selected');
                if (currentSelected && currentSelected.classList.contains('is-video-item')) {
                    return; // Already on video, do nothing
                }

                // Find the first video item
                var videoItem = mediaList.querySelector('.product__media-item.is-video-item:not(.is-filtered)');
                if (!videoItem) return;

                // Use flickity-carousel select method
                if (mediaList.select) {
                    mediaList.select('#' + videoItem.id);
                } else {
                    // Fallback: wait for flickity instance
                    if (mediaList.flickityInstance) {
                        mediaList.flickityInstance.then(function(flkty) {
                            flkty.selectCell(videoItem);
                        });
                    } else {
                        // Use flickity-controls
                        var flickityControls = document.querySelector('flickity-controls[controls="' + mediaList.id + '"]');
                        if (flickityControls) {
                            var controlButton = flickityControls.querySelector('[aria-controls="' + videoItem.id + '"]');
                            if (controlButton) {
                                controlButton.click();
                            }
                        }
                    }
                }
            });
        });
    }

    // Initialize play buttons after Flickity is ready
    flickityElement.addEventListener('flickity:ready', initPlayButtons);

    // Also initialize immediately in case Flickity is already ready
    initPlayButtons();

    // Remove native video controls on mobile devices
    function removeVideoControlsOnMobile() {
        var isMobile = window.innerWidth <= 999;
        var videos = flickityElement.querySelectorAll('video');

        videos.forEach(function(video) {
            if (isMobile) {
                // Remove controls attribute on mobile to hide native controls UI
                video.removeAttribute('controls');
            } else {
                // Restore controls on desktop
                if (!video.hasAttribute('controls')) {
                    video.setAttribute('controls', 'controls');
                }
            }
        });
    }

    // Remove controls on load and when Flickity updates
    removeVideoControlsOnMobile();
    flickityElement.addEventListener('flickity:ready', removeVideoControlsOnMobile);
    flickityElement.addEventListener('flickity:select', removeVideoControlsOnMobile);

    // Also handle window resize
    var resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(removeVideoControlsOnMobile, 100);
    });

    // Filter out video items when Tapcart is present (works like desktop - filters on all screen sizes)
    function filterVideosForTapcart() {
        if (isTapcartPresent()) {
            // Add is-filtered class to video items to exclude them from carousel
            // Use data attribute to track items we filtered
            var videoItems = flickityElement.querySelectorAll('.product__media-item.is-video-item');
            videoItems.forEach(function(item) {
                if (!item.hasAttribute('data-tapcart-filtered')) {
                    item.classList.add('is-filtered');
                    item.setAttribute('data-tapcart-filtered', 'true');
                }
            });

            // Also filter video dots and thumbnails
            var videoDots = document.querySelectorAll('.dots-nav__item.is-video-dot');
            videoDots.forEach(function(dot) {
                if (!dot.hasAttribute('data-tapcart-filtered')) {
                    dot.classList.add('is-filtered');
                    dot.setAttribute('data-tapcart-filtered', 'true');
                }
            });

            var videoThumbnails = document.querySelectorAll('.product__thumbnail-item.is-video-thumbnail');
            videoThumbnails.forEach(function(thumb) {
                if (!thumb.hasAttribute('data-tapcart-filtered')) {
                    thumb.classList.add('is-filtered');
                    thumb.setAttribute('data-tapcart-filtered', 'true');
                }
            });

            // Trigger Flickity update to recalculate cells
            var flkty = ThemeFlickity.data(flickityElement);
            if (flkty) {
                flkty.reloadCells();
            }
        } else {
            // Remove is-filtered class only from items we filtered
            var filteredVideoItems = flickityElement.querySelectorAll('.product__media-item.is-video-item[data-tapcart-filtered="true"]');
            filteredVideoItems.forEach(function(item) {
                item.classList.remove('is-filtered');
                item.removeAttribute('data-tapcart-filtered');
            });

            var filteredVideoDots = document.querySelectorAll('.dots-nav__item.is-video-dot[data-tapcart-filtered="true"]');
            filteredVideoDots.forEach(function(dot) {
                dot.classList.remove('is-filtered');
                dot.removeAttribute('data-tapcart-filtered');
            });

            var filteredVideoThumbnails = document.querySelectorAll('.product__thumbnail-item.is-video-thumbnail[data-tapcart-filtered="true"]');
            filteredVideoThumbnails.forEach(function(thumb) {
                thumb.classList.remove('is-filtered');
                thumb.removeAttribute('data-tapcart-filtered');
            });

            // Trigger Flickity update
            var flkty = ThemeFlickity.data(flickityElement);
            if (flkty) {
                flkty.reloadCells();
            }
        }
    }

    // Filter videos on desktop on load and when Flickity is ready
    filterVideosForDesktop();
    flickityElement.addEventListener('flickity:ready', filterVideosForDesktop);

    // Check for Tapcart on load and when Flickity is ready
    filterVideosForTapcart();
    flickityElement.addEventListener('flickity:ready', filterVideosForTapcart);

    // Also check on resize
    var resizeTimeout2;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout2);
        resizeTimeout2 = setTimeout(function() {
            filterVideosForDesktop();
            filterVideosForTapcart();
        }, 100);
    });

    // Watch for Tapcart class changes
    var tapcartObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                filterVideosForTapcart();
            }
        });
    });

    if (document.body) {
        tapcartObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    // Also check if Tapcart element appears
    var tapcartElementObserver = new MutationObserver(function() {
        filterVideosForTapcart();
    });

    tapcartElementObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
});

function syncMidFieldsOnForm(form, variantId) {
  if (!form || !variantId) return;

  const midMapInput = form.querySelector('[data-mid-map-json]');
  const midMapRaw = midMapInput ? midMapInput.value : '';
  if (!midMapRaw) return;

  let midByVariantId;
  try {
    midByVariantId = JSON.parse(midMapRaw);
  } catch (error) {
    console.error('[MID] Failed to parse MID variant map JSON', {
      error,
      formId: form.id || null,
      variantId
    });
    return;
  }

  const values = midByVariantId[String(variantId)] || {};

  ['midcode', 'midname', 'midaddress'].forEach((fieldName) => {
    const input = form.querySelector(`[data-mid-field="${fieldName}"]`);
    if (!input) return;

    const value = (values[fieldName] || '').trim();
    input.value = value;

    if (value) {
      input.removeAttribute('disabled');
    } else {
      input.setAttribute('disabled', 'disabled');
    }
  });
}


document.addEventListener('variant:changed', (event) => {
  const form = event.target;
  const variant = event.detail && event.detail.variant;

  if (!form || !variant || !variant.id) return;
  syncMidFieldsOnForm(form, variant.id);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[is="product-form"]').forEach((form) => {
    if (!form.querySelector('[data-mid-map-json]')) return;
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    syncMidFieldsOnForm(form, variantId);
  });

});
